import { render, staticRenderFns } from "./createPayment.vue?vue&type=template&id=b068fc32&"
import script from "./createPayment.vue?vue&type=script&lang=js&"
export * from "./createPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports